import "core-js/stable";
import "regenerator-runtime/runtime";

import App from './App';

export default App;